import React from "react";
import { getLabelByKey, useChangeableItems } from "store/useDynamicLabel";

const Footer = ({ note }) => {
  const changeableItems = useChangeableItems();
  const getLabel = (itemKey) => getLabelByKey(changeableItems, itemKey);

  return (
    <footer className="qp-footer">
      <div className="qp-footer-line" />
      <p>{note || "All the Best!"}</p>
      <p className="qp-end">— {`End of ${getLabel('QUESTION_PAPER')}`} —</p>
    </footer>
  );
}

export default Footer;
